import { createTRPCProxyClient, httpBatchLink, loggerLink, getFetch } from '@trpc/client';
// import { tap } from '@trpc/server/observable';
import type { AppRouter } from '@backend/server/trpc/app.trpc';
import { TRPC_BASE_URL } from '@/lib/constants';
import { getFingerprint } from '@/services/fingerprintService';
import { inferRouterInputs, inferRouterOutputs } from '@trpc/server';

const url = TRPC_BASE_URL;

// Función helper para añadir el fingerprint a los headers
const addFingerprintToHeaders = async (headers: Record<string, string> = {}) => {
  try {
    const fingerprint = await getFingerprint();
    return {
      ...headers,
      'x-device-fp': fingerprint,
    };
  } catch (error) {
    console.error('Error al obtener fingerprint para TRPC:', error);
    return headers;
  }
};

export const trpcClient = createTRPCProxyClient<AppRouter>({
  links: [
    // () =>
    //   ({ op, next }) => {
    //     console.log('->', op.type, op.path, op.input);

    //     return next(op)
    //     // .pipe(
    //     //   tap({
    //     //     next(result) {
    //     //       console.log('<-', op.type, op.path, op.input, ':', result);
    //     //     },
    //     //   }),
    //     // );
    //   },
    httpBatchLink({
      url,
      async headers() {
        return await addFingerprintToHeaders();
      },
    }),
  ],
});

export const authedClient = createTRPCProxyClient<AppRouter>({
  links: [
    loggerLink(),
    httpBatchLink({
      url,
      async headers() {
        return await addFingerprintToHeaders();
      },
      fetch: async (url, options) => {
        const fetch = getFetch();
        return fetch(url, {
          ...options,
          credentials: 'include',
        });
      },
    }),
  ],
});


export type ClientOutput = inferRouterOutputs<AppRouter>;
export type ClientInput = inferRouterInputs<AppRouter>;
// Función para obtener el perfil público y ratings de un taller por su slug
export const getPublicProfileBySlug = async (slug: string) => {
  try {
    const publicProfile = await trpcClient.publicProfile.getBySlug.query({ slug });
    return publicProfile;
  } catch (error) {
    console.error('Error al obtener el perfil público:', error);
    throw error;
  }
};
